import { lazy, Suspense } from "react";
import Header from "../../Components/HeaderPublic";
import { HeroCarousel, InfoBlocks } from "../../Components/landing";
import Button from "../../Components/ButtonWhatsapp";
import Footer from "../../Components/Footer";

// Lazy load de componentes que están debajo del fold
const Clients = lazy(() =>
  import("../../Components/landing/Clients").then((m) => ({
    default: m.default,
  })),
);
const Methodology = lazy(() =>
  import("../../Components/landing/Methodology").then((m) => ({
    default: m.default,
  })),
);
const Tools = lazy(() =>
  import("../../Components/landing/Tools").then((m) => ({
    default: m.default,
  })),
);
const Ecosystem = lazy(() =>
  import("../../Components/landing/Ecosystem").then((m) => ({
    default: m.default,
  })),
);
const FaqAccordions = lazy(() =>
  import("../../Components/landing/FaqAccordions").then((m) => ({
    default: m.default,
  })),
);

export default function Home() {
  return (
    <div className="absolute left-0 right-0 h-screen justify-between">
      <Header />

      {/*-------------------- Hero con Carrusel --------------------*/}
      <HeroCarousel autoPlayDelay={6000} />

      {/*-------------------- Bloques de Información --------------------*/}
      <InfoBlocks />

      {/*-------------------- Contenido lazy (debajo del fold) --------------------*/}
      <Suspense fallback={null}>
        <Clients />
        <Methodology />
        <Tools />
        <Ecosystem />
        <FaqAccordions />
      </Suspense>

      {/*-------------------- Componentes Compartidos --------------------*/}
      <Button />
      <Footer />
    </div>
  );
}
